import { isEqual } from 'lodash';
import { updateMatch } from 'connect/actions';
import { MembershipPlan, MembershipStatus } from 'common/constants';

export const clinicIsPremium = clinic =>
  clinic.membership?.plan === MembershipPlan.PREMIUM
  && clinic.membership?.status === MembershipStatus.ACTIVE;

export const doesArrayContainDuplicates = array => {
  const set = new Set(array);
  return set.size !== array.length;
};

/**
 *
 * @param {function} dispatcher redux useDispatch() function
 * @param {string} matchId
 * @param {string} matchToken
 * @param {object} match match object
 * @param {object} experiment full experiment object (e.g. EXPERIMENTS.REDESIGN_EXPERIMENT)
 */
export const tryUpdateMatchExperimentData = (
  dispatcher,
  matchId,
  matchToken,
  match,
  experimentName,
  experimentVariant,
) => {
  const experimentMetadata = {
    experimentName,
    experimentVariant,
  };

  if (
    !experimentMetadata
    || isEqual(match.experimentData, experimentMetadata)
  ) {
    return;
  }

  dispatcher(updateMatch(matchId, matchToken, experimentMetadata));
};
